// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Turv","location":"Header_location__1FvHm"};